import React, { useState } from 'react';
import { ArrowLeft, Download, Calendar, MapPin, Clock, TrendingUp, TrendingDown, Shield, Activity } from 'lucide-react';
import { StarField } from '../components/Background/StarField';
export function SafetyPage() {
  const [selectedCampus, setSelectedCampus] = useState<'north' | 'south'>('north');
  const [timeRange, setTimeRange] = useState('week');
  // 模拟数据 - 基于原型图
  const data = {
    overview: {
      totalReports: 127,
      unprocessed: 37,
      playing: 22,
      other: 5,
      verbalAbuse: 39,
      fighting: 7,
      falseReport: 18
    },
    reportTypeDistribution: [{
      type: '言语',
      count: 45,
      percentage: 35.4,
      color: '#38BDF8'
    }, {
      type: '身体冲突',
      count: 32,
      percentage: 25.2,
      color: '#F472B6'
    }, {
      type: '孤立',
      count: 28,
      percentage: 22.0,
      color: '#A78BFA'
    }, {
      type: '骚扰',
      count: 15,
      percentage: 11.8,
      color: '#FB923C'
    }, {
      type: '其他',
      count: 7,
      percentage: 5.5,
      color: '#94A3B8'
    }],
    processingRatio: {
      processed: 71,
      unprocessed: 29,
      misjudged: 12
    },
    buildingStats: [{
      building: '东教学楼',
      count: 3,
      trend: 'up'
    }, {
      building: '西教学楼',
      count: 2,
      trend: 'down'
    }, {
      building: '公寓楼',
      count: 0,
      trend: 'stable'
    }, {
      building: '综合楼',
      count: 8,
      trend: 'up'
    }, {
      building: '实验楼',
      count: 11,
      trend: 'up'
    }],
    recentAlerts: [{
      date: '2025-07-31',
      count: 3
    }, {
      date: '2025-07-30',
      count: 2
    }, {
      date: '2025-07-29',
      count: 0
    }, {
      date: '2025-07-28',
      count: 3
    }, {
      date: '2025-07-27',
      count: 2
    }, {
      date: '2025-07-26',
      count: 2
    }, {
      date: '2025-07-25',
      count: 2
    }],
    triggerTypes: {
      victimBehavior: ['被欺凌者', '主动求助', '被动防御'],
      mainActor: ['主动欺凌', '跟随起哄', '言语攻击'],
      bystander: ['旁观者', '围观助威', '视而不见'],
      reportedPerson: ['受害人', '目击者', '第三方']
    }
  };
  return <div className="relative w-full min-h-screen bg-[#0B1120] overflow-auto" data-id="element-1222">
      {/* Background */}
      <StarField data-id="element-1223" />

      {/* Header */}
      <header className="sticky top-0 z-50 bg-gradient-to-b from-[#0B1120] to-[#0B1120]/95 backdrop-blur-sm border-b border-[#38BDF8]/20" data-id="element-1224">
        <div className="px-8 py-4" data-id="element-1225">
          <div className="flex items-center justify-between" data-id="element-1226">
            {/* Left: Back & Title */}
            <div className="flex items-center gap-6" data-id="element-1227">
              <button onClick={() => window.history.back()} className="p-2 glass-panel rounded-lg hover:bg-white/10 transition-colors" data-id="element-1228">
                <ArrowLeft className="w-5 h-5 text-gray-400" data-id="element-1229" />
              </button>
              <div data-id="element-1230">
                <h1 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-1231">
                  <div className="w-10 h-10 rounded-xl bg-[#38BDF8]/20 flex items-center justify-center border border-[#38BDF8]/30" data-id="element-1232">
                    <Shield className="w-6 h-6 text-[#38BDF8]" data-id="element-1233" />
                  </div>
                  易教·守护 平安校园
                </h1>
                <p className="text-sm text-gray-400 mt-1" data-id="element-1234">
                  全域感知 · 智能预警 · 精准干预
                </p>
              </div>
            </div>

            {/* Right: Actions */}
            <div className="flex items-center gap-4" data-id="element-1235">
              <div className="flex items-center gap-2 glass-panel px-3 py-2 rounded-lg border border-white/10" data-id="element-1236">
                <Calendar className="w-4 h-4 text-gray-400" data-id="element-1237" />
                <select value={timeRange} onChange={e => setTimeRange(e.target.value)} className="bg-transparent text-white text-sm focus:outline-none" data-id="element-1238">
                  <option value="week" data-id="element-1239">本周</option>
                  <option value="month" data-id="element-1240">本月</option>
                  <option value="semester" data-id="element-1241">本学期</option>
                </select>
              </div>
              <button className="flex items-center gap-2 glass-panel px-4 py-2 rounded-lg hover:bg-white/10 transition-colors border border-white/10" data-id="element-1242">
                <Download className="w-4 h-4 text-gray-400" data-id="element-1243" />
                <span className="text-white text-sm" data-id="element-1244">导出报告</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-8 py-6" data-id="element-1245">
        {/* Top Stats Bar */}
        <div className="grid grid-cols-7 gap-4 mb-6" data-id="element-1246">
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-1247">
            <div className="text-xs text-gray-400 mb-1" data-id="element-1248">报警总计</div>
            <div className="text-3xl font-bold text-[#38BDF8]" data-id="element-1249">
              {data.overview.totalReports}
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-1250">
            <div className="text-xs text-gray-400 mb-1" data-id="element-1251">未处理</div>
            <div className="text-3xl font-bold text-orange-400" data-id="element-1252">
              {data.overview.unprocessed}
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-1253">
            <div className="text-xs text-gray-400 mb-1" data-id="element-1254">玩闹</div>
            <div className="text-3xl font-bold text-yellow-400" data-id="element-1255">
              {data.overview.playing}
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-1256">
            <div className="text-xs text-gray-400 mb-1" data-id="element-1257">其他</div>
            <div className="text-3xl font-bold text-gray-400" data-id="element-1258">
              {data.overview.other}
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-1259">
            <div className="text-xs text-gray-400 mb-1" data-id="element-1260">谩骂冲突</div>
            <div className="text-3xl font-bold text-red-400" data-id="element-1261">
              {data.overview.verbalAbuse}
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-1262">
            <div className="text-xs text-gray-400 mb-1" data-id="element-1263">肢体冲突</div>
            <div className="text-3xl font-bold text-purple-400" data-id="element-1264">
              {data.overview.fighting}
            </div>
          </div>
          <div className="glass-panel p-4 rounded-xl border border-white/10 text-center" data-id="element-1265">
            <div className="text-xs text-gray-400 mb-1" data-id="element-1266">谎报</div>
            <div className="text-3xl font-bold text-blue-400" data-id="element-1267">
              {data.overview.falseReport}
            </div>
          </div>
        </div>

        {/* Main Grid Layout */}
        <div className="grid grid-cols-12 gap-6" data-id="element-1268">
          {/* Left Column - Charts */}
          <div className="col-span-3 space-y-6" data-id="element-1269">
            {/* Report Type Distribution */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-1270">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-1271">
                <div className="w-1 h-5 bg-[#38BDF8] rounded-full" data-id="element-1272"></div>
                报警类型统计
              </h3>
              <div className="relative w-48 h-48 mx-auto mb-4" data-id="element-1273">
                <svg viewBox="0 0 200 200" className="transform -rotate-90" data-id="element-1274">
                  {data.reportTypeDistribution.map((item, index, arr) => {
                  const total = arr.reduce((sum, i) => sum + i.count, 0);
                  const startAngle = arr.slice(0, index).reduce((sum, i) => sum + i.count / total * 360, 0);
                  const angle = item.count / total * 360;
                  const startRad = startAngle * Math.PI / 180;
                  const endRad = (startAngle + angle) * Math.PI / 180;
                  const largeArc = angle > 180 ? 1 : 0;
                  const x1 = 100 + 80 * Math.cos(startRad);
                  const y1 = 100 + 80 * Math.sin(startRad);
                  const x2 = 100 + 80 * Math.cos(endRad);
                  const y2 = 100 + 80 * Math.sin(endRad);
                  return <path key={index} d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`} fill={item.color} opacity="0.8" data-id="element-1275" />;
                })}
                  <circle cx="100" cy="100" r="50" fill="#0B1120" data-id="element-1276" />
                </svg>
              </div>
              <div className="space-y-2" data-id="element-1277">
                {data.reportTypeDistribution.map((item, index) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-1278">
                    <div className="flex items-center gap-2" data-id="element-1279">
                      <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: item.color
                  }} data-id="element-1280"></div>
                      <span className="text-gray-300" data-id="element-1281">{item.type}</span>
                    </div>
                    <span className="text-white font-bold" data-id="element-1282">
                      {item.percentage}%
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Processing Ratio */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-1283">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-1284">
                <div className="w-1 h-5 bg-[#38BDF8] rounded-full" data-id="element-1285"></div>
                处理占比
              </h3>
              <div className="relative w-48 h-48 mx-auto mb-4" data-id="element-1286">
                <svg viewBox="0 0 200 200" className="transform -rotate-90" data-id="element-1287">
                  <path d="M 100 100 L 180 100 A 80 80 0 1 1 100 20 Z" fill="#22C55E" opacity="0.8" data-id="element-1288" />
                  <path d="M 100 100 L 100 20 A 80 80 0 0 1 147.4 147.4 Z" fill="#F59E0B" opacity="0.8" data-id="element-1289" />
                  <path d="M 100 100 L 147.4 147.4 A 80 80 0 0 1 180 100 Z" fill="#EF4444" opacity="0.8" data-id="element-1290" />
                  <circle cx="100" cy="100" r="50" fill="#0B1120" data-id="element-1291" />
                </svg>
              </div>
              <div className="space-y-2" data-id="element-1292">
                <div className="flex items-center justify-between text-sm" data-id="element-1293">
                  <div className="flex items-center gap-2" data-id="element-1294">
                    <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-1295"></div>
                    <span className="text-gray-300" data-id="element-1296">处理</span>
                  </div>
                  <span className="text-white font-bold" data-id="element-1297">
                    {data.processingRatio.processed}%
                  </span>
                </div>
                <div className="flex items-center justify-between text-sm" data-id="element-1298">
                  <div className="flex items-center gap-2" data-id="element-1299">
                    <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-1300"></div>
                    <span className="text-gray-300" data-id="element-1301">未处理</span>
                  </div>
                  <span className="text-white font-bold" data-id="element-1302">
                    {data.processingRatio.unprocessed}%
                  </span>
                </div>
                <div className="flex items-center justify-between text-sm" data-id="element-1303">
                  <div className="flex items-center gap-2" data-id="element-1304">
                    <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-1305"></div>
                    <span className="text-gray-300" data-id="element-1306">误报</span>
                  </div>
                  <span className="text-white font-bold" data-id="element-1307">
                    {data.processingRatio.misjudged}%
                  </span>
                </div>
              </div>
            </div>

            {/* Trigger Type Design */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-1308">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-1309">
                <div className="w-1 h-5 bg-[#38BDF8] rounded-full" data-id="element-1310"></div>
                触发类型设计
              </h3>
              <div className="relative w-48 h-48 mx-auto" data-id="element-1311">
                {/* Diamond shape with 4 quadrants */}
                <svg viewBox="0 0 200 200" className="w-full h-full" data-id="element-1312">
                  <polygon points="100,20 180,100 100,180 20,100" fill="none" stroke="#38BDF8" strokeWidth="2" opacity="0.3" data-id="element-1313" />
                  <line x1="100" y1="20" x2="100" y2="180" stroke="#38BDF8" strokeWidth="1" opacity="0.3" data-id="element-1314" />
                  <line x1="20" y1="100" x2="180" y2="100" stroke="#38BDF8" strokeWidth="1" opacity="0.3" data-id="element-1315" />

                  {/* Labels */}
                  <text x="100" y="15" textAnchor="middle" fill="#38BDF8" fontSize="12" data-id="element-1316">
                    主动欺凌
                  </text>
                  <text x="185" y="105" textAnchor="start" fill="#F472B6" fontSize="12" data-id="element-1317">
                    主动求助
                  </text>
                  <text x="100" y="195" textAnchor="middle" fill="#A78BFA" fontSize="12" data-id="element-1318">
                    旁观者
                  </text>
                  <text x="15" y="105" textAnchor="end" fill="#FB923C" fontSize="12" data-id="element-1319">
                    受害人
                  </text>

                  {/* Center point */}
                  <circle cx="100" cy="100" r="8" fill="#0EA5E9" data-id="element-1320" />
                </svg>
              </div>
              <div className="mt-4 space-y-2 text-xs" data-id="element-1321">
                <div className="flex items-center gap-2" data-id="element-1322">
                  <div className="w-2 h-2 rounded-full bg-[#38BDF8]" data-id="element-1323"></div>
                  <span className="text-gray-400" data-id="element-1324">施欺凌者</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-1325">
                  <div className="w-2 h-2 rounded-full bg-[#F472B6]" data-id="element-1326"></div>
                  <span className="text-gray-400" data-id="element-1327">被欺凌者</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-1328">
                  <div className="w-2 h-2 rounded-full bg-[#A78BFA]" data-id="element-1329"></div>
                  <span className="text-gray-400" data-id="element-1330">旁观者</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-1331">
                  <div className="w-2 h-2 rounded-full bg-[#FB923C]" data-id="element-1332"></div>
                  <span className="text-gray-400" data-id="element-1333">受害人</span>
                </div>
              </div>
            </div>
          </div>

          {/* Center Column - 3D Campus Map */}
          <div className="col-span-6" data-id="element-1334">
            <div className="glass-panel p-6 rounded-xl border border-white/10 h-full" data-id="element-1335">
              <div className="flex items-center justify-between mb-4" data-id="element-1336">
                <h3 className="text-white font-bold flex items-center gap-2" data-id="element-1337">
                  <MapPin className="w-5 h-5 text-[#38BDF8]" data-id="element-1338" />
                  学校报警情况总览
                </h3>
                <div className="flex gap-2" data-id="element-1339">
                  <button onClick={() => setSelectedCampus('north')} className={`px-4 py-1.5 rounded-lg text-sm transition-colors ${selectedCampus === 'north' ? 'bg-[#38BDF8]/20 text-[#38BDF8] border border-[#38BDF8]/50' : 'glass-panel text-gray-400 hover:text-white'}`} data-id="element-1340">
                    北校区
                  </button>
                  <button onClick={() => setSelectedCampus('south')} className={`px-4 py-1.5 rounded-lg text-sm transition-colors ${selectedCampus === 'south' ? 'bg-[#38BDF8]/20 text-[#38BDF8] border border-[#38BDF8]/50' : 'glass-panel text-gray-400 hover:text-white'}`} data-id="element-1341">
                    南校区
                  </button>
                </div>
              </div>

              {/* 3D Campus Visualization Placeholder */}
              <div className="relative w-full h-[500px] bg-gradient-to-br from-[#0B1120] to-[#1a2332] rounded-xl border border-[#38BDF8]/20 overflow-hidden" data-id="element-1342">
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-1343">
                  <div className="text-center" data-id="element-1344">
                    <div className="w-64 h-64 mx-auto mb-4 relative" data-id="element-1345">
                      {/* Simplified 3D building representation */}
                      <div className="absolute inset-0 flex items-center justify-center" data-id="element-1346">
                        <div className="grid grid-cols-3 gap-4" data-id="element-1347">
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(i => <div key={i} className="w-16 h-20 bg-gradient-to-t from-[#38BDF8]/20 to-[#38BDF8]/5 border border-[#38BDF8]/30 rounded-t-lg relative" style={{
                          transform: `perspective(500px) rotateX(${Math.random() * 10}deg) rotateY(${Math.random() * 10}deg)`
                        }} data-id="element-1348">
                              {Math.random() > 0.7 && <div className="absolute -top-2 -right-2 w-4 h-4 bg-red-500 rounded-full animate-pulse" data-id="element-1349"></div>}
                            </div>)}
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-400 text-sm" data-id="element-1350">3D 校园地图可视化</p>
                    <p className="text-gray-500 text-xs mt-1" data-id="element-1351">
                      实时显示各建筑报警情况
                    </p>
                  </div>
                </div>

                {/* Hotspot indicators */}
                <div className="absolute top-4 left-4 glass-panel px-3 py-2 rounded-lg" data-id="element-1352">
                  <div className="flex items-center gap-2" data-id="element-1353">
                    <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse" data-id="element-1354"></div>
                    <span className="text-white text-sm" data-id="element-1355">高发区域</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Building Stats & Timeline */}
          <div className="col-span-3 space-y-6" data-id="element-1356">
            {/* Building Statistics */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-1357">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-1358">
                <Activity className="w-5 h-5 text-[#38BDF8]" data-id="element-1359" />
                建筑统计
              </h3>
              <div className="space-y-3" data-id="element-1360">
                {data.buildingStats.map((building, index) => <div key={index} className="flex items-center justify-between p-3 bg-white/5 rounded-lg" data-id="element-1361">
                    <div className="flex items-center gap-3" data-id="element-1362">
                      <div className="w-8 h-8 rounded-lg bg-[#38BDF8]/20 flex items-center justify-center" data-id="element-1363">
                        <span className="text-[#38BDF8] font-bold text-sm" data-id="element-1364">
                          {building.count}
                        </span>
                      </div>
                      <span className="text-white text-sm" data-id="element-1365">
                        {building.building}
                      </span>
                    </div>
                    {building.trend === 'up' && <TrendingUp className="w-4 h-4 text-red-400" data-id="element-1366" />}
                    {building.trend === 'down' && <TrendingDown className="w-4 h-4 text-green-400" data-id="element-1367" />}
                    {building.trend === 'stable' && <div className="w-4 h-0.5 bg-gray-400" data-id="element-1368"></div>}
                  </div>)}
              </div>
            </div>

            {/* Recent Alerts Timeline */}
            <div className="glass-panel p-6 rounded-xl border border-white/10" data-id="element-1369">
              <h3 className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-1370">
                <Clock className="w-5 h-5 text-[#38BDF8]" data-id="element-1371" />
                报警量统计
              </h3>
              <div className="space-y-3" data-id="element-1372">
                <div className="flex items-center justify-between text-xs text-gray-400 mb-2" data-id="element-1373">
                  <span data-id="element-1374">日期</span>
                  <span data-id="element-1375">报警次数</span>
                </div>
                {data.recentAlerts.map((alert, index) => <div key={index} className="flex items-center justify-between" data-id="element-1376">
                    <span className="text-gray-400 text-sm" data-id="element-1377">{alert.date}</span>
                    <div className="flex items-center gap-2" data-id="element-1378">
                      <div className="w-24 h-2 bg-white/5 rounded-full overflow-hidden" data-id="element-1379">
                        <div className="h-full bg-gradient-to-r from-[#38BDF8] to-[#0EA5E9] rounded-full" style={{
                      width: `${alert.count / 3 * 100}%`
                    }} data-id="element-1380"></div>
                      </div>
                      <span className="text-white font-bold text-sm w-6 text-right" data-id="element-1381">
                        {alert.count}
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}